<template>
  <div id="root" class="row">
    <div v-if="evaluationList.length > 0" class="col-12">
      <div
        v-for="(evaluation, index) in evaluationList"
        :id="'row_e' + evaluation.studentEvaluationId"
        :key="evaluation.studentEvaluationId"
        class="pt-0"
      >
        <div v-if="showAsDiscussion">
          <EvaluationInformationRow
            :items-eval="evaluation"
            :discussion-statuses="discussionCollections.discussionStatuses"
            :rejection-reasons="discussionCollections.rejectionReasons"
            :is-submitted="evaluationSaved"
            :show-error="true"
            @remove-rejection="onRemoveRejection(evaluation, $event)"
            @add-rejection="onAddRejection(evaluation, $event)"
            @on-delete="removeEvaluation(evaluation, index)"
            @on-determine-change="onDetermineChange(evaluation, $event)"
            @on-discussion-status-change="
              onDiscussionStatusChange(evaluation, $event)
            "
            @on-push-comments="onPushComments(evaluation, $event)"
          />
        </div>
        <div v-else class="datarow">
          <callout
            :has-toggle="hasIcon(evaluation)"
            :opened="evaluation.isOpened ? null : false"
            :controlled="true"
            class="mb-3 mt-1"
            @click:open="collapseEvaluation(evaluation)"
          >
            <div class="row py-2">
              <div class="col-md-10">
                <div class="row pt-2">
                  <div
                    class="col-md-1 col-sm-12 d-flex justify-content-center align-items-center"
                  >
                    <div
                      :class="{ disabled: !evaluation.editable || disabled }"
                    >
                      <div class="input-group position-relative cb-move">
                        <input
                          :id="'checkbox_e' + evaluation.studentEvaluationId"
                          v-model="evaluation.isSelectedFlag"
                          type="checkbox"
                          class="checkbox option-input"
                          :change="onSelected(evaluation)"
                        />
                        <label
                          :for="'checkbox_e' + evaluation.studentEvaluationId"
                          class="checkbox-label"
                        >
                          <span v-if="evaluation.isSelectedFlag != null">
                            <em class="ic-check" />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Tipo de Servicio:
                    </div>
                    <div
                      class="mt-2 type-name disabled"
                      :class="{ off: evaluation.isSelectedFlag }"
                      @click="collapseEvaluation(evaluation)"
                    >
                      <span
                        :class="{
                          'icon-accordion': hasIcon(evaluation) != undefined,
                        }"
                      >
                        {{ evaluation.serviceTypeName }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Servicio:
                    </div>
                    <div
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable,
                      }"
                    >
                      <span>{{ evaluation.disciplineTypeName }}</span>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Estatus:
                    </div>
                    <div
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable,
                      }"
                    >
                      <span>
                        {{ evaluation.statusName }}
                      </span>
                    </div>
                  </div>
                  <div class="col-md-2 col-sm-6 text-left">
                    <div class="font-weight-normal font-14 color-gray--6">
                      Aceptada:
                    </div>
                    <div
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable &&
                          !evaluationSaved,
                      }"
                    >
                      <CustomRadioGroup
                        v-model="evaluation.isApprovedByParentFlag"
                        :name="`accepted-e${evaluation.studentEvaluationId}`"
                        :options="radioButtonsOptions"
                        :is-disabled="evaluation.isAcceptedDisabled"
                        is-inline
                        class="ml-n3"
                        @input="approvementChanged(evaluation)"
                      />
                    </div>
                  </div>
                  <div
                    class="col-md-3 col-sm-12 text-left"
                    v-show="!isOcupacional(evaluation)"
                  >
                    <div
                      v-if="hasOptionDeterminate"
                      class="font-weight-normal font-14 color-gray--6"
                    >
                      ¿Esta evaluación será utilizada en una determinación de
                      elegibilidad?
                    </div>
                    <div
                      v-if="hasOptionDeterminate"
                      class="mt-2 disabled"
                      :class="{
                        off:
                          !disabled &&
                          evaluation.isSelectedFlag &&
                          evaluation.editable &&
                          !evaluationSaved,
                      }"
                    >
                      <CustomRadioGroup
                        :value="getDetermination(evaluation)"
                        :name="
                          `determinated-${evaluation.studentEvaluationId}-${index}`
                        "
                        :options="radioButtonsOptions"
                        :is-disabled="
                          evaluation.restrictAdditionalEvaluationSelection ||
                            !evaluation.isApprovedByParentFlag ||
                            !evaluation.editable ||
                            disabled
                        "
                        is-inline
                        class="ml-n3"
                        @input="onDeterminated($event, evaluation)"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div class="col disabled off">
                  <div class="dropdown">
                    <DropDown
                      :items="getActions(evaluation, index)"
                      title="Acciones"
                    />
                  </div>
                </div>
              </div>
            </div>
          </callout>

          <a
            :ref="`ei-collapse-e${evaluation.studentEvaluationId}`"
            class="hidden"
            data-toggle="collapse"
            :href="`#ei-collapse-e${evaluation.studentEvaluationId}`"
            aria-expanded="false"
            :aria-controls="`ei-collapse-e${evaluation.studentEvaluationId}`"
          />

          <div
            :id="`ei-collapse-e${evaluation.studentEvaluationId}`"
            :class="{ off: evaluation.isSelectedFlag && evaluation.editable }"
            class="col-12 collapse"
          >
            <RejectEvaluationsModal
              v-if="
                evaluation.isSelectedFlag &&
                  evaluation.isApprovedByParentFlag == false
              "
              :disabled="evaluationSaved"
              v-model="evaluation.rejection"
              :is-selected-for-rejection="
                evaluation.isSelectedFlag &&
                  evaluation.isApprovedByParentFlag == false
              "
              @rejectEvaluationsSave="onSaveNotAccepted(evaluation)"
              @rejectEvaluationsCancel="onCancelNotAccepted(evaluation)"
              @close="onCloseEvaluation(evaluation)"
            />
          </div>
        </div>
      </div>
      <Error
        v-if="errors.length == 0"
        variant="no-border"
        :message="error"
        class="mt-1"
      />
      <div v-else>
        <Error
          v-for="err in errors"
          :key="err"
          variant="no-border"
          :message="err"
          class="mt-1"
        />
      </div>
    </div>
    <div v-else class="col-12 text-center">
      <span class="font-weight-normal">
        Al momento el estudiante no cuenta con evaluaciones disponibles para
        discusi&oacute;n.
      </span>
    </div>
    <Error
      v-if="shouldShowEligibilityDiscussionError"
      message="Al únicamente contar con una evaluación y esta no ser utilizada para completar el proceso de determinación de elegibilidad debe realizar el proceso en la pantalla de Discusión de Evaluaciones."
      is-alert-mode
    />
    <!-- Actions -->
    <div
      v-if="!evaluationSaved"
      class="d-flex flex-row-reverse bd-highlight w-100 my-4 mr-3"
    >
      <div class="mx-0 bd-highlight ml-2">
        <ActionButton
          v-if="!showAsDiscussion"
          data-target="#add-previous-evaluations-modal"
          data-toggle="modal"
          data-backdrop="static"
          variant="success"
          i="fas fa-file-plus"
          @click="alertOpenModal"
        >
          A&ntilde;adir
        </ActionButton>
        <ActionButton
          v-else-if="showAsDiscussion"
          type="submit"
          text="Añadir"
          i="fa fa-file-plus pl-2"
          variant="success btn-block"
          class="px-1 actions"
          @click="addEvaluationHandler"
        />
      </div>
      <div class="mx-0 bd-highlight">
        <ActionButton
          v-if="!showAsDiscussion"
          variant="success"
          i="fas fa-file-edit"
          @click="selectedEvaluationsModalOpen"
        >
          Modificar
        </ActionButton>
        <ActionButton
          v-else-if="showAsDiscussion"
          type="submit"
          text="Seleccionar otras evaluaciones"
          i="fa fa-edit pl-2"
          variant="outline-success"
          class="px-2 mr-2 actions"
          @click="openCloseSelectManyEvaluations"
        />
      </div>
    </div>

    <div class="col-12" v-if="showAsDiscussion">
      <select-many-evaluations
        v-if="selectManyEvaluationsOpened"
        ref="selectManySelection"
        :evaluations="computedAvailable"
        :selected-evaluations="computedAdded"
        @cancel-select-many="openCloseSelectManyEvaluations"
        @continue-select-many="applyEvaluationSelectedHandler"
      />
    </div>
    <div class="col-12" v-else>
      <CustomAddRemoveListPopup
        ref="selectedEvaluationsModalRef"
        object-key="value"
        object-description="text"
        title="Selección de Evaluaciones"
        added-column-description="Evaluaciones Seleccionadas"
        removed-column-description="Evaluaciones Disponibles"
        add-all-description="Seleccionar Todas"
        remove-all-description="Remover Todas"
        :added-list="computedAdded"
        :removed-list="computedAvailable"
        :btn-classes="'hidden'"
        @updated="applyEvaluationSelectedHandler"
      />
    </div>
  </div>
</template>

<script>
// TODO use verdaccio packages
import CustomAddRemoveListPopup from '@/components/common/CustomAddRemoveListPopup';
import EvaluationInformationRow from './components/EvaluationInformationRow.vue';
import RejectEvaluationsModal from './RejectEvaluationsModalV2';
import generalService from '@/services/pei/general';
import alertService from '@/mixin/alert.mixin';
import ActionButton from 'ActionButton';
import DropDown from 'dropdown';
import CustomRadioGroup from '@/components/common/CustomRadio';
import SelectManyEvaluations from './components/SelectManyEvaluations';
// import CustomCheckBox from "@/components/common/CustomCheckbox";
import Error from '@/components/common/Error.vue';
import Callout from '@/components/common/callout/View';
import DISCIPLINE_TYPES from '@/utils/constants/disciplineTypes';
import { discussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';

export default {
  name: 'Evaluations',
  components: {
    // AddPreviousEvaluationsModal,
    CustomAddRemoveListPopup,
    RejectEvaluationsModal,
    ActionButton,
    CustomRadioGroup,
    Error,
    Callout,
    DropDown,
    EvaluationInformationRow,
    SelectManyEvaluations,
  },
  props: {
    evaluationSaved: { type: Boolean, default: false },
    hasOptionDeterminate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: () => false },
    enoughInformation: { type: Boolean, default: () => false },
    error: { type: String, default: () => null },
    errors: { type: Array, default: () => [] },
    register: { type: Array, default: () => [] },
    hasManyOptionsDeterminated: { type: Boolean, default: false },
    evaluationServiceType: { type: Number, default: () => 2 },
    isInitialPostRegistry: { type: Boolean, default: () => null },
    showAsDiscussion: { type: Boolean, default: false },
    discussionCollections: {
      type: Object,
      default: () => ({
        discussionStatuses: [],
        rejectionReasons: [],
        allRejectionReasons: [],
      }),
    },
    //New
    value: {
      type: Object,
      default: () => {
        return new {
          evaluationsAddedList: [],
          availables: [],
          evaluationInformationData: [],
        }();
      },
    },
    getEvaluations: {
      type: Function,
      default: undefined,
    },
  },
  data() {
    return {
      selectedRow: null,
      statusClasses: {
        previa: 'badge-erase',
        completada: 'badge-complete',
        confirmada: 'badge-signed',
      },
      radioButtonsOptions: [
        { label: 'Si', value: true },
        { label: 'No', value: false },
      ],
      statusCanDisccus: [
        'Previa',
        'Confirmada',
        'Realizada por Remedio Provisional',
      ],
      //Clone for change data evaluated
      evaluations: [],
      selectManyEvaluationsOpened: false,
    };
  },

  methods: {
    addEvaluationHandler() {
      this.$emit('go-to-add-student-evaluation');
    },
    openCloseSelectManyEvaluations() {
      this.selectManyEvaluationsOpened = !this.selectManyEvaluationsOpened;
    },
    getActions(evaluation, index) {
      if (evaluation == undefined) return [];

      let actions = [
        {
          label: 'Remover Evaluación',
          icon: 'fas fa-times-circle text-red',
          border: 'none',
          visible:
            !this.disabled &&
            ((!evaluation.isSelectedFlag && this.evaluationSaved) ||
              !this.evaluationSaved),
          click: () => this.removeEvaluation(evaluation, index),
        },
        {
          label: 'Ver Documento Adjunto',
          icon: 'fas fa-search text-green',
          border: 'none',
          visible: evaluation.statusName != 'Completada',
          click: () => this.downloadDocument(evaluation),
        },
      ];
      if (actions.filter((f) => f.visible).length == 0) {
        actions.push({
          name: 'empty',
          label: 'No hay opciones',
          icon: 'fas fa-warning text-green',
          border: 'none',
          visible: true,
        });
      }
      return actions;
    },
    approvementChanged(evaluation) {
      this.collapseEvaluation(evaluation);
      this.$forceUpdate();
    },
    //Validate if need show icon or not
    hasIcon(evaluation) {
      if (evaluation.isApprovedByParentFlag == null) return false;
      else if (!evaluation.isApprovedByParentFlag) return true;
      else return false;
    },
    //For checkbox (testing)
    onSelected(evaluation) {
      if (!evaluation.isSelectedFlag) {
        //By default
        evaluation.rejection.rejectionById = null;
        evaluation.rejection.rejectionComment = null;
      }
    },
    // Show modal for add evaluations
    alertOpenModal() {
      this.$emit('addPreviousEvaluation', true);
    },
    selectedEvaluationsModalOpen() {
      this.$refs.selectedEvaluationsModalRef.show();
    },
    getDetermination(evaluation) {
      if (this.hasManyOptionsDeterminated) {
        return null;
      }
      if (
        evaluation.restrictAdditionalEvaluationSelection ||
        evaluation.isApprovedByParentFlag == false
      ) {
        return false;
      }
      return evaluation.isDeterminated;
    },
    // event handler modal
    getStatusClass(status) {
      let statusClass = '';
      switch (status) {
        case 'Previa':
          statusClass = 'badge-erase';
          break;
        case 'Completada':
          statusClass = 'badge-complete';
          break;
        case 'Confirmada':
          statusClass = 'badge-signed';
          break;
        case 'Realizada por Remedio Provisional':
          statusClass = 'badge-pending-funds';
          break;
      }

      return statusClass;
    },
    //Actions of Menu
    removeEvaluation(evaluation, index) {
      const addedList = this.computedAdded.filter(
        (x) => x.value !== evaluation.studentEvaluationId.toString()
      );
      const availableList = this.computedAvailable;

      availableList.push({ value: evaluation.studentEvaluationId });

      this.applyEvaluationSelectedHandler(addedList, availableList);

      this.value.evaluationInformationData.splice(index, 1);
      this.$forceUpdate();
    },
    async downloadDocument(evaluation) {
      if (
        !evaluation.studentEvaluationId ||
        (!evaluation.studentEvaluationsDocumentIds &&
          !evaluation.studentEvaluationsAttachmentIds)
      ) {
        alertService.methods.ShowAlertModal(
          'Atención',
          'La evaluación no contiene documentos adjuntos.',
          null
        );
      }
      let response = await generalService.downloadDocumentByAttachmentId(
        evaluation.studentEvaluationsDocumentIds,
        evaluation.studentEvaluationsAttachmentIds
      );
      if (response) {
        alertService.methods.ShowAlertModal(
          'Atención',
          'La evaluación no contiene documentos adjuntos.',
          null
        );
      }
    },
    //End Menu
    applyEvaluationSelectedHandler(
      evaluationsAddedList,
      evaluationsExcludedList
    ) {
      if (this.getEvaluations === undefined) {
        /* eslint-disable no-debugger, no-console */
        console.warn("Event: Get Evaluatios don't defined");
        return;
      }

      this.getEvaluations(
        evaluationsAddedList, //.map((x) => x.value).join(", "),
        evaluationsExcludedList, //.map((x) => x.value).join(", "),
        this.isInitialPostRegistry,
        this.evaluationServiceType != null ? this.evaluationServiceType : 2,
        this.disabled,
        this.$route.params.evaluationDateId
      );
      if (this.showAsDiscussion) {
        this.selectManyEvaluationsOpened = false;
      }
    },
    getCollapse(studentEvaluationId) {
      let link = this.$refs[`ei-collapse-e${studentEvaluationId}`][0];
      const isOpen = link.getAttribute('aria-expanded') == 'true';
      return { link, isOpen };
    },
    collapseItem({ studentEvaluationId }) {
      let { link } = this.getCollapse(studentEvaluationId);
      link.click();
    },
    collapseEvaluation(evaluation) {
      if (this.hasIcon(evaluation) != undefined) {
        //Avoid change values
        evaluation.isOpened = evaluation.isOpened ? false : true;
        this.collapseItem(evaluation);
      }
    },
    findEvaluation(studentEvaluationId) {
      const row = this.value.evaluationInformationData.find(
        (e) => e.studentEvaluationId == studentEvaluationId
      );
      return row;
    },
    onSaveNotAccepted(evaluation) {
      const row = this.findEvaluation(evaluation.studentEvaluationId);
      row.rejectionById = evaluation.rejection.rejectionById.id;
      row.rejectionComment = evaluation.rejection.rejectionComment;
      this.collapseItem(row);
    },
    onCancelNotAccepted(evaluation) {
      let { isOpen, link } = this.getCollapse(evaluation.studentEvaluationId);
      const row = this.findEvaluation(evaluation.studentEvaluationId);
      row.isApprovedByParentFlag = null;
      if (isOpen) {
        link.click();
      }
      this.$forceUpdate();
    },
    onCloseEvaluation(evaluation) {
      let { isOpen, link } = this.getCollapse(evaluation.studentEvaluationId);
      if (isOpen) {
        link.click();
      }
      this.$forceUpdate();
    },
    isOcupacional(evaluation) {
      return evaluation.disciplineTypeId === DISCIPLINE_TYPES.Ocupacional;
    },
    onDeterminated(event, evaluation) {
      evaluation.isDeterminated = event;
      evaluation.isImpedimentEvaluationFlag = event;

      // We hide the eligibility panel if is false and there is no evaluation marked with eligible.
      if (
        event ||
        (!event &&
          !this.value.evaluationInformationData.some(
            (x) => x.isImpedimentEvaluationFlag
          ))
      ) {
        this.$emit('determinated', event); //WHY on the parent is called 'determinated' >\ its not explicit!
      }
    },
    // Validations.
    // Validates that there is an evaluation in an accepted and determined state.
    evaluationAcceptedAndDetermined() {
      if (this.value.evaluationInformationData) {
        return this.value.evaluationInformationData.some(
          (x) => x.isApprovedByParentFlag == true && x.isDeterminated == true
        );
      }
      return false;
    },
    // Validates that all evaluations are in an accepted or rejected state.
    allEvaluationsAcceptedOrRejected() {
      if (this.value.evaluationInformationData) {
        return this.value.evaluationInformationData.every(
          (x) =>
            x.isApprovedByParentFlag == true ||
            x.isApprovedByParentFlag == false
        );
      }
      return false;
    },

    onRemoveRejection(evaluation, selectedReason) {
      const reason = this.discussionCollections.rejectionReasons.find(
        (x) => x.id == selectedReason.id
      );
      reason.comment = selectedReason.comment;

      const index = this.evaluationList.findIndex(
        (x) => x.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationList[index].rejectionReasons.push(reason);

      let filteredList = this.discussionCollections.rejectionReasons.filter(
        (x) => x.id !== selectedReason.id
      );
      this.discussionCollections.rejectionReasons = filteredList;
    },
    onAddRejection(evaluation, id) {
      const reason = this.discussionCollections.allRejectionReasons.find(
        (x) => x.id == id
      );

      this.discussionCollections.rejectionReasons.push(reason);

      this.discussionCollections.rejectionReasons = this.discussionCollections.rejectionReasons.sort(
        (a, b) => a.id - b.id
      );

      const filteredList = evaluation.rejectionReasons.filter(
        (x) => x.id !== id
      );

      const index = this.evaluationList.findIndex(
        (x) => x.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationList[index].rejectionReasons = filteredList;
    },
    onDetermineChange(evaluation, determineOption) {
      evaluation.isImpedimentEvaluationFlag = determineOption;

      const index = this.evaluationList.findIndex(
        (x) => x.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationList[index].isImpedimentEvaluationFlag = determineOption;
      this.evaluationList[index].isDeterminated = determineOption;
      this.evaluationList[index].eligibilityFlag = determineOption ? '1' : '0';

      this.discussionCollections.rejectionReasons = this.discussionCollections.allRejectionReasons;
      if (
        determineOption ||
        (!determineOption &&
          !this.value.evaluationInformationData.some(
            (x) => x.isImpedimentEvaluationFlag
          ))
      ) {
        this.$emit('determinated', determineOption);
      }
    },
    onDiscussionStatusChange(evaluation, discussionStatus) {
      const index = this.evaluationList.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationList[index].statusId = discussionStatus?.id;
      this.evaluationList[index].discussionStatusId = discussionStatus?.id;
      this.evaluationList[index].isApprovedByParentFlag = [
        discussionStatuses.accepted,
        discussionStatuses.partialAccepted,
      ].includes(discussionStatus?.id);
    },
    onPushComments(evaluation, reasons) {
      const index = this.evaluationList.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationList[index].rejectionReasons = reasons;
    },
  },
  computed: {
    evaluationList() {
      let listEvaluation = this.value.evaluationInformationData;
      if (this.register.length > 0) {
        listEvaluation = this.value.evaluationInformationData.filter(
          (existingItem) =>
            !this.register.some(
              (item) =>
                item.studentEvaluationId === existingItem.studentEvaluationId
            )
        );
      }
      this.value.evaluationInformationData = listEvaluation.concat(
        this.register
      );

      this.value.evaluationInformationData = (
        this.value.evaluationInformationData ?? []
      ).map((x) => ({
        ...x,
        rejectionReasons: x.rejectionReasons ?? [],
        isImpedimentEvaluationFlag: x.isImpedimentEvaluationFlag ?? null,
        isDeterminated: x.isDeterminated ?? null,
        eligibilityFlag: x.eligibilityFlag ?? '0',
        discussionStatusId: x.discussionStatusId ?? null,
        isSelectedFlag: this.showAsDiscussion
          ? true
          : x.isSelectedFlag ?? false,
      }));
      return this.value.evaluationInformationData;
    },

    computedAvailable() {
      let availables = this.value.availables;
      if (this.computedAdded.length > 0) {
        availables = availables.filter(
          (x) =>
            this.computedAdded.findIndex((i) => i.value === x.toString()) === -1
        );
      }
      let filteredAvailable = availables;
      if (this.register.length > 0) {
        filteredAvailable = availables.filter(
          (itemA) =>
            !this.register.some(
              (itemB) => `${itemB.studentEvaluationId}` === itemA.value
            )
        );
      }
      return filteredAvailable;
    },
    computedAdded() {
      return this.evaluationList.map((x) => ({
        id: x.studentEvaluationId,
        name: x.evaluationDate + ' - ' + x.disciplineTypeName,
        text: x.evaluationDate + ' - ' + x.disciplineTypeName,
        isApprovedByParentFlag: x.isApprovedByParentFlag,
        value: x.studentEvaluationId.toString(),
      }));
    },
    shouldShowEligibilityDiscussionError() {
      return this.evaluationList.every((c) => !c.isDeterminated);
    },
  },
};
</script>

<style src="@/assets/css/component/checkbox.css" scoped></style>
<style src="@/assets/css/component/radio-button.css"></style>

<style scoped>
#root >>> td,
#root >>> tr,
#root >>> th {
  text-align: center;
}

#root >>> .vgt-ei tbody {
  background: rgb(225, 228, 224);
  background: linear-gradient(
    180deg,
    rgba(225, 228, 224, 1) 0%,
    rgba(250, 251, 251, 1) 8%
  );
}

.cb-move {
  z-index: 5;
  left: 80%;
  top: 18%;
}

.p-62 {
  padding: 20px 0 !important;
}

.icon-accordion:before {
  font-family: 'Font Awesome 5 Pro';
  opacity: 1;
  position: absolute;
  left: 15%;
  top: 18%;
  font-size: 26px;
}

a[aria-expanded='false'] ~ .type-name:not([disabled]) .icon-accordion:before {
  content: '\f138';
  color: #3f5b60;
}

a[aria-expanded='true'] ~ .type-name:not([disabled]) .icon-accordion:before {
  content: '\f13a';
  font-weight: 900;
  color: #2db782;
}

#root >>> .vgt-ei thead th {
  border-top: none;
  font-weight: bold;
}

#root >>> .vgt-ei td,
#root >>> .vgt-ei td {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}

#root >>> .vgt-ei thead th {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
}

#root >>> .vgt-ei th:first-child {
  border-radius: 10px 0 0 0;
}

#root >>> .vgt-ei th:last-child {
  border-radius: 0 10px 0 0;
}

/*columna estatus*/
#root >>> .vgt-ei .tablebtn {
  padding: 0px 10px;
}

.datarow,
.dataheader {
  text-align: center;
}

.dataheader {
  background-color: #3f5b60;
  color: white;
  font-weight: 400;
  border-bottom: 2px white solid;
  border-radius: 10px 10px 0 0;
  padding: 0.75rem;
}

.datarow {
  background-color: rgba(0, 0, 0, 0.025);
}

.datarow >>> .col {
  padding: 1em 10px;
  vertical-align: top;
  text-align: center;
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #11291b;
}

/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 100%;
  height: 42px;
  line-height: 20px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
}
.badge-cancel {
  background: #f4ceb3;
}
.badge-complete {
  background: #f8ea80;
}
.badge-signed {
  background: #a3e5b3;
}
.badge-incomplete {
  background: #f4ceb3;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #dee8b5;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #a7e6dc;
}

.dropdown-menu {
  margin-top: 3px;
}

.btn.focus,
.btn:focus {
  outline: 0;
  box-shadow: none;
}
.dropdown-toggle::after {
  display: none;
}
.dropleft-toggle::before {
  display: none;
}
.dropleft .dropdown-toggle::before {
  display: none;
}
.tiny-chevron {
  font-size: 12px;
  line-height: 20px;
  color: #11291b;
}

/*acciones en tabla */
#root >>> .vgt-eiDropdown .vs__dropdown-toggle {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #2db782;
  border-radius: 4px;
}

#root >>> .vgt-eiDropdown .vs__dropdown-menu {
  margin-top: 5px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
}

#root >>> .vgt-eiDropdown .vs__search::placeholder {
  border: none !important;
}

#root >>> .vgt-eiDropdown .vs__dropdown-option {
  font: 400 15px/24px Lato;
}

#root >>> .vgt-eiDropdown .vs__dropdown-option:first-child {
  font-weight: bold;
}

#root >>> .vgt-eiDropdown .vs__dropdown-option--highlight {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  color: #11291b;
  font: 400 15px/24px Lato;
}

/* checkbox de edición y class para cells */
input[type='checkbox'] {
  height: 15px;
  width: auto !important;
  margin: auto;
}

.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.disabled.off {
  opacity: 1;
  pointer-events: initial;
}

.panel-simple a,
.panel-simple a:visited,
.panel-simple a:link {
  text-decoration: none;
  color: #ffffff;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}
.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: '';
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-item {
  font: Bold 16px/19px Lato;
}

@media (min-width: 992px) {
  .btn-dropdown-actions {
    width: 4.5rem;
    font-size: 0.7rem;
    margin-right: 0px;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 6rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    width: 7.4375rem;
  }
}

.input-group .circle {
  border: 1px solid #b7b7b7;
}

.input-group .entry-label {
  font-weight: 400;
}
</style>
